export default __webpack_public_path__ + "static/comparisons-mission-critical-1d8f0542d7a274a36cf4fe91d42c855d.webp";